/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Smart Sash Admin API
 * RESTful API for Smart Sash device management, user authentication, and system administration
 * OpenAPI spec version: 0.13.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AssignableRoleDTO,
  ChangePasswordRequest,
  CreateUserRequest,
  CreateUserResponse,
  ForgotPasswordRequest,
  GetApiUserListParams,
  GetApiUserParams,
  GetApiUserSearchParams,
  PostApiUserImportBody,
  ProblemDetails,
  ResetPasswordRequest,
  UpdateUserRequest,
  UserDTO,
  UserDTOPaginationResult,
  UserImportResponse,
  UserMoveCompletedPayload,
  UserMoveConflictPayload,
  UserMoveRequest,
  UserNameDTO
} from '../../models';

import { customInstance } from '../../../http/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiUser = (
    params?: GetApiUserParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserDTOPaginationResult>(
      {url: `/api/User`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiUserInfiniteQueryKey = (params?: GetApiUserParams,) => {
    return [
    'infinite', `/api/User`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiUserQueryKey = (params?: GetApiUserParams,) => {
    return [
    `/api/User`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiUserInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiUser>>>, TError = unknown>(params?: GetApiUserParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiUserInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUser>>> = ({ signal }) => getApiUser(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiUserInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUser>>>
export type GetApiUserInfiniteQueryError = unknown


export function useGetApiUserInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiUser>>>, TError = unknown>(
 params: undefined |  GetApiUserParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUser>>,
          TError,
          Awaited<ReturnType<typeof getApiUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUserInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiUser>>>, TError = unknown>(
 params?: GetApiUserParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUser>>,
          TError,
          Awaited<ReturnType<typeof getApiUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUserInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiUser>>>, TError = unknown>(
 params?: GetApiUserParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiUserInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiUser>>>, TError = unknown>(
 params?: GetApiUserParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiUserInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiUserQueryOptions = <TData = Awaited<ReturnType<typeof getApiUser>>, TError = unknown>(params?: GetApiUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiUserQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUser>>> = ({ signal }) => getApiUser(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiUserQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUser>>>
export type GetApiUserQueryError = unknown


export function useGetApiUser<TData = Awaited<ReturnType<typeof getApiUser>>, TError = unknown>(
 params: undefined |  GetApiUserParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUser>>,
          TError,
          Awaited<ReturnType<typeof getApiUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUser<TData = Awaited<ReturnType<typeof getApiUser>>, TError = unknown>(
 params?: GetApiUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUser>>,
          TError,
          Awaited<ReturnType<typeof getApiUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUser<TData = Awaited<ReturnType<typeof getApiUser>>, TError = unknown>(
 params?: GetApiUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiUser<TData = Awaited<ReturnType<typeof getApiUser>>, TError = unknown>(
 params?: GetApiUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiUserQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiUserList = (
    params?: GetApiUserListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserDTOPaginationResult>(
      {url: `/api/User/list`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiUserListInfiniteQueryKey = (params?: GetApiUserListParams,) => {
    return [
    'infinite', `/api/User/list`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiUserListQueryKey = (params?: GetApiUserListParams,) => {
    return [
    `/api/User/list`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiUserListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiUserList>>>, TError = ProblemDetails>(params?: GetApiUserListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiUserListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserList>>> = ({ signal }) => getApiUserList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiUserListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUserList>>>
export type GetApiUserListInfiniteQueryError = ProblemDetails


export function useGetApiUserListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiUserList>>>, TError = ProblemDetails>(
 params: undefined |  GetApiUserListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserList>>,
          TError,
          Awaited<ReturnType<typeof getApiUserList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUserListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiUserList>>>, TError = ProblemDetails>(
 params?: GetApiUserListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserList>>,
          TError,
          Awaited<ReturnType<typeof getApiUserList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUserListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiUserList>>>, TError = ProblemDetails>(
 params?: GetApiUserListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiUserListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiUserList>>>, TError = ProblemDetails>(
 params?: GetApiUserListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiUserListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiUserListQueryOptions = <TData = Awaited<ReturnType<typeof getApiUserList>>, TError = ProblemDetails>(params?: GetApiUserListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiUserListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserList>>> = ({ signal }) => getApiUserList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiUserList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiUserListQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUserList>>>
export type GetApiUserListQueryError = ProblemDetails


export function useGetApiUserList<TData = Awaited<ReturnType<typeof getApiUserList>>, TError = ProblemDetails>(
 params: undefined |  GetApiUserListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserList>>,
          TError,
          Awaited<ReturnType<typeof getApiUserList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUserList<TData = Awaited<ReturnType<typeof getApiUserList>>, TError = ProblemDetails>(
 params?: GetApiUserListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserList>>,
          TError,
          Awaited<ReturnType<typeof getApiUserList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUserList<TData = Awaited<ReturnType<typeof getApiUserList>>, TError = ProblemDetails>(
 params?: GetApiUserListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiUserList<TData = Awaited<ReturnType<typeof getApiUserList>>, TError = ProblemDetails>(
 params?: GetApiUserListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiUserListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiUserSearch = (
    params?: GetApiUserSearchParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserNameDTO[] | null>(
      {url: `/api/User/search`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiUserSearchInfiniteQueryKey = (params?: GetApiUserSearchParams,) => {
    return [
    'infinite', `/api/User/search`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiUserSearchQueryKey = (params?: GetApiUserSearchParams,) => {
    return [
    `/api/User/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiUserSearchInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiUserSearch>>>, TError = unknown>(params?: GetApiUserSearchParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiUserSearchInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserSearch>>> = ({ signal }) => getApiUserSearch(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserSearch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiUserSearchInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUserSearch>>>
export type GetApiUserSearchInfiniteQueryError = unknown


export function useGetApiUserSearchInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiUserSearch>>>, TError = unknown>(
 params: undefined |  GetApiUserSearchParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserSearch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserSearch>>,
          TError,
          Awaited<ReturnType<typeof getApiUserSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUserSearchInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiUserSearch>>>, TError = unknown>(
 params?: GetApiUserSearchParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserSearch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserSearch>>,
          TError,
          Awaited<ReturnType<typeof getApiUserSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUserSearchInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiUserSearch>>>, TError = unknown>(
 params?: GetApiUserSearchParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiUserSearchInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiUserSearch>>>, TError = unknown>(
 params?: GetApiUserSearchParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiUserSearchInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiUserSearchQueryOptions = <TData = Awaited<ReturnType<typeof getApiUserSearch>>, TError = unknown>(params?: GetApiUserSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiUserSearchQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserSearch>>> = ({ signal }) => getApiUserSearch(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiUserSearch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiUserSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUserSearch>>>
export type GetApiUserSearchQueryError = unknown


export function useGetApiUserSearch<TData = Awaited<ReturnType<typeof getApiUserSearch>>, TError = unknown>(
 params: undefined |  GetApiUserSearchParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserSearch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserSearch>>,
          TError,
          Awaited<ReturnType<typeof getApiUserSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUserSearch<TData = Awaited<ReturnType<typeof getApiUserSearch>>, TError = unknown>(
 params?: GetApiUserSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserSearch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserSearch>>,
          TError,
          Awaited<ReturnType<typeof getApiUserSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUserSearch<TData = Awaited<ReturnType<typeof getApiUserSearch>>, TError = unknown>(
 params?: GetApiUserSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiUserSearch<TData = Awaited<ReturnType<typeof getApiUserSearch>>, TError = unknown>(
 params?: GetApiUserSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiUserSearchQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiUserInstitutionIdUserId = (
    institutionId: string,
    userId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserDTO>(
      {url: `/api/User/${institutionId}/${userId}`, method: 'GET', signal
    },
      options);
    }




export const getGetApiUserInstitutionIdUserIdInfiniteQueryKey = (institutionId: string,
    userId: string,) => {
    return [
    'infinite', `/api/User/${institutionId}/${userId}`
    ] as const;
    }

export const getGetApiUserInstitutionIdUserIdQueryKey = (institutionId: string,
    userId: string,) => {
    return [
    `/api/User/${institutionId}/${userId}`
    ] as const;
    }


export const getGetApiUserInstitutionIdUserIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>>, TError = ProblemDetails>(institutionId: string,
    userId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiUserInstitutionIdUserIdInfiniteQueryKey(institutionId,userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>> = ({ signal }) => getApiUserInstitutionIdUserId(institutionId,userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: institutionId !== null && institutionId !== undefined && userId !== null && userId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiUserInstitutionIdUserIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>>
export type GetApiUserInstitutionIdUserIdInfiniteQueryError = ProblemDetails


export function useGetApiUserInstitutionIdUserIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>>, TError = ProblemDetails>(
 institutionId: string,
    userId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>,
          TError,
          Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUserInstitutionIdUserIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>>, TError = ProblemDetails>(
 institutionId: string,
    userId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>,
          TError,
          Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUserInstitutionIdUserIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>>, TError = ProblemDetails>(
 institutionId: string,
    userId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiUserInstitutionIdUserIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>>, TError = ProblemDetails>(
 institutionId: string,
    userId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiUserInstitutionIdUserIdInfiniteQueryOptions(institutionId,userId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiUserInstitutionIdUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>, TError = ProblemDetails>(institutionId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiUserInstitutionIdUserIdQueryKey(institutionId,userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>> = ({ signal }) => getApiUserInstitutionIdUserId(institutionId,userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: institutionId !== null && institutionId !== undefined && userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiUserInstitutionIdUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>>
export type GetApiUserInstitutionIdUserIdQueryError = ProblemDetails


export function useGetApiUserInstitutionIdUserId<TData = Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>, TError = ProblemDetails>(
 institutionId: string,
    userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>,
          TError,
          Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUserInstitutionIdUserId<TData = Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>, TError = ProblemDetails>(
 institutionId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>,
          TError,
          Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUserInstitutionIdUserId<TData = Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>, TError = ProblemDetails>(
 institutionId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiUserInstitutionIdUserId<TData = Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>, TError = ProblemDetails>(
 institutionId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserInstitutionIdUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiUserInstitutionIdUserIdQueryOptions(institutionId,userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiUserInstitutionIdUserId = (
    institutionId: string,
    userId: string,
    updateUserRequest?: UpdateUserRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserDTO>(
      {url: `/api/User/${institutionId}/${userId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserRequest, signal
    },
      options);
    }




export const getPutApiUserInstitutionIdUserIdMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiUserInstitutionIdUserId>>, TError,{institutionId: string;userId: string;data?: UpdateUserRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiUserInstitutionIdUserId>>, TError,{institutionId: string;userId: string;data?: UpdateUserRequest}, TContext> => {

const mutationKey = ['putApiUserInstitutionIdUserId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiUserInstitutionIdUserId>>, {institutionId: string;userId: string;data?: UpdateUserRequest}> = (props) => {
          const {institutionId,userId,data} = props ?? {};

          return  putApiUserInstitutionIdUserId(institutionId,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiUserInstitutionIdUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiUserInstitutionIdUserId>>>
    export type PutApiUserInstitutionIdUserIdMutationBody = UpdateUserRequest | undefined
    export type PutApiUserInstitutionIdUserIdMutationError = ProblemDetails

    export const usePutApiUserInstitutionIdUserId = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiUserInstitutionIdUserId>>, TError,{institutionId: string;userId: string;data?: UpdateUserRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiUserInstitutionIdUserId>>,
        TError,
        {institutionId: string;userId: string;data?: UpdateUserRequest},
        TContext
      > => {
      return useMutation(getPutApiUserInstitutionIdUserIdMutationOptions(options), queryClient);
    }
    export const deleteApiUserInstitutionIdUserId = (
    institutionId: string,
    userId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/User/${institutionId}/${userId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteApiUserInstitutionIdUserIdMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiUserInstitutionIdUserId>>, TError,{institutionId: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiUserInstitutionIdUserId>>, TError,{institutionId: string;userId: string}, TContext> => {

const mutationKey = ['deleteApiUserInstitutionIdUserId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiUserInstitutionIdUserId>>, {institutionId: string;userId: string}> = (props) => {
          const {institutionId,userId} = props ?? {};

          return  deleteApiUserInstitutionIdUserId(institutionId,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiUserInstitutionIdUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiUserInstitutionIdUserId>>>

    export type DeleteApiUserInstitutionIdUserIdMutationError = ProblemDetails

    export const useDeleteApiUserInstitutionIdUserId = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiUserInstitutionIdUserId>>, TError,{institutionId: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiUserInstitutionIdUserId>>,
        TError,
        {institutionId: string;userId: string},
        TContext
      > => {
      return useMutation(getDeleteApiUserInstitutionIdUserIdMutationOptions(options), queryClient);
    }
    export const postApiUserAdmin = (
    createUserRequest?: CreateUserRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CreateUserResponse>(
      {url: `/api/User/admin`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserRequest, signal
    },
      options);
    }




export const getPostApiUserAdminMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUserAdmin>>, TError,{data?: CreateUserRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiUserAdmin>>, TError,{data?: CreateUserRequest}, TContext> => {

const mutationKey = ['postApiUserAdmin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUserAdmin>>, {data?: CreateUserRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiUserAdmin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiUserAdminMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUserAdmin>>>
    export type PostApiUserAdminMutationBody = CreateUserRequest | undefined
    export type PostApiUserAdminMutationError = ProblemDetails

    export const usePostApiUserAdmin = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUserAdmin>>, TError,{data?: CreateUserRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiUserAdmin>>,
        TError,
        {data?: CreateUserRequest},
        TContext
      > => {
      return useMutation(getPostApiUserAdminMutationOptions(options), queryClient);
    }
    export const postApiUserUser = (
    createUserRequest?: CreateUserRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CreateUserResponse>(
      {url: `/api/User/user`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserRequest, signal
    },
      options);
    }




export const getPostApiUserUserMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUserUser>>, TError,{data?: CreateUserRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiUserUser>>, TError,{data?: CreateUserRequest}, TContext> => {

const mutationKey = ['postApiUserUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUserUser>>, {data?: CreateUserRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiUserUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiUserUserMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUserUser>>>
    export type PostApiUserUserMutationBody = CreateUserRequest | undefined
    export type PostApiUserUserMutationError = ProblemDetails

    export const usePostApiUserUser = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUserUser>>, TError,{data?: CreateUserRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiUserUser>>,
        TError,
        {data?: CreateUserRequest},
        TContext
      > => {
      return useMutation(getPostApiUserUserMutationOptions(options), queryClient);
    }
    export const postApiUserImport = (
    postApiUserImportBody?: PostApiUserImportBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(postApiUserImportBody?.file !== undefined) {
 formData.append(`file`, postApiUserImportBody.file);
 }
if(postApiUserImportBody?.options !== undefined) {
 formData.append(`options`, postApiUserImportBody.options);
 }

      return customInstance<UserImportResponse>(
      {url: `/api/User/import`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getPostApiUserImportMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUserImport>>, TError,{data?: PostApiUserImportBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiUserImport>>, TError,{data?: PostApiUserImportBody}, TContext> => {

const mutationKey = ['postApiUserImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUserImport>>, {data?: PostApiUserImportBody}> = (props) => {
          const {data} = props ?? {};

          return  postApiUserImport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiUserImportMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUserImport>>>
    export type PostApiUserImportMutationBody = PostApiUserImportBody | undefined
    export type PostApiUserImportMutationError = ProblemDetails | void

    export const usePostApiUserImport = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUserImport>>, TError,{data?: PostApiUserImportBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiUserImport>>,
        TError,
        {data?: PostApiUserImportBody},
        TContext
      > => {
      return useMutation(getPostApiUserImportMutationOptions(options), queryClient);
    }
    export const postApiUserInstitutionIdUserIdMove = (
    institutionId: string,
    userId: string,
    userMoveRequest?: UserMoveRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserMoveCompletedPayload>(
      {url: `/api/User/${institutionId}/${userId}/move`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userMoveRequest, signal
    },
      options);
    }




export const getPostApiUserInstitutionIdUserIdMoveMutationOptions = <TError = unknown | null | UserMoveConflictPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUserInstitutionIdUserIdMove>>, TError,{institutionId: string;userId: string;data?: UserMoveRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiUserInstitutionIdUserIdMove>>, TError,{institutionId: string;userId: string;data?: UserMoveRequest}, TContext> => {

const mutationKey = ['postApiUserInstitutionIdUserIdMove'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUserInstitutionIdUserIdMove>>, {institutionId: string;userId: string;data?: UserMoveRequest}> = (props) => {
          const {institutionId,userId,data} = props ?? {};

          return  postApiUserInstitutionIdUserIdMove(institutionId,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiUserInstitutionIdUserIdMoveMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUserInstitutionIdUserIdMove>>>
    export type PostApiUserInstitutionIdUserIdMoveMutationBody = UserMoveRequest | undefined
    export type PostApiUserInstitutionIdUserIdMoveMutationError = unknown | null | UserMoveConflictPayload

    export const usePostApiUserInstitutionIdUserIdMove = <TError = unknown | null | UserMoveConflictPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUserInstitutionIdUserIdMove>>, TError,{institutionId: string;userId: string;data?: UserMoveRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiUserInstitutionIdUserIdMove>>,
        TError,
        {institutionId: string;userId: string;data?: UserMoveRequest},
        TContext
      > => {
      return useMutation(getPostApiUserInstitutionIdUserIdMoveMutationOptions(options), queryClient);
    }
    export const putApiUserChangePassword = (
    changePasswordRequest?: ChangePasswordRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/User/change-password`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: changePasswordRequest, signal
    },
      options);
    }




export const getPutApiUserChangePasswordMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiUserChangePassword>>, TError,{data?: ChangePasswordRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiUserChangePassword>>, TError,{data?: ChangePasswordRequest}, TContext> => {

const mutationKey = ['putApiUserChangePassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiUserChangePassword>>, {data?: ChangePasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  putApiUserChangePassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiUserChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof putApiUserChangePassword>>>
    export type PutApiUserChangePasswordMutationBody = ChangePasswordRequest | undefined
    export type PutApiUserChangePasswordMutationError = ProblemDetails

    export const usePutApiUserChangePassword = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiUserChangePassword>>, TError,{data?: ChangePasswordRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiUserChangePassword>>,
        TError,
        {data?: ChangePasswordRequest},
        TContext
      > => {
      return useMutation(getPutApiUserChangePasswordMutationOptions(options), queryClient);
    }
    export const postApiUserForgotPassword = (
    forgotPasswordRequest?: ForgotPasswordRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/User/forgot-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: forgotPasswordRequest, signal
    },
      options);
    }




export const getPostApiUserForgotPasswordMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUserForgotPassword>>, TError,{data?: ForgotPasswordRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiUserForgotPassword>>, TError,{data?: ForgotPasswordRequest}, TContext> => {

const mutationKey = ['postApiUserForgotPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUserForgotPassword>>, {data?: ForgotPasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiUserForgotPassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiUserForgotPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUserForgotPassword>>>
    export type PostApiUserForgotPasswordMutationBody = ForgotPasswordRequest | undefined
    export type PostApiUserForgotPasswordMutationError = unknown

    export const usePostApiUserForgotPassword = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUserForgotPassword>>, TError,{data?: ForgotPasswordRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiUserForgotPassword>>,
        TError,
        {data?: ForgotPasswordRequest},
        TContext
      > => {
      return useMutation(getPostApiUserForgotPasswordMutationOptions(options), queryClient);
    }
    export const postApiUserResetPassword = (
    resetPasswordRequest?: ResetPasswordRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/User/reset-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resetPasswordRequest, signal
    },
      options);
    }




export const getPostApiUserResetPasswordMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUserResetPassword>>, TError,{data?: ResetPasswordRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiUserResetPassword>>, TError,{data?: ResetPasswordRequest}, TContext> => {

const mutationKey = ['postApiUserResetPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUserResetPassword>>, {data?: ResetPasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiUserResetPassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiUserResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUserResetPassword>>>
    export type PostApiUserResetPasswordMutationBody = ResetPasswordRequest | undefined
    export type PostApiUserResetPasswordMutationError = ProblemDetails

    export const usePostApiUserResetPassword = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUserResetPassword>>, TError,{data?: ResetPasswordRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiUserResetPassword>>,
        TError,
        {data?: ResetPasswordRequest},
        TContext
      > => {
      return useMutation(getPostApiUserResetPasswordMutationOptions(options), queryClient);
    }
    export const postApiUserInstitutionIdUserIdRegenerateTempPassword = (
    institutionId: string,
    userId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/User/${institutionId}/${userId}/regenerate-temp-password`, method: 'POST', signal
    },
      options);
    }




export const getPostApiUserInstitutionIdUserIdRegenerateTempPasswordMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUserInstitutionIdUserIdRegenerateTempPassword>>, TError,{institutionId: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiUserInstitutionIdUserIdRegenerateTempPassword>>, TError,{institutionId: string;userId: string}, TContext> => {

const mutationKey = ['postApiUserInstitutionIdUserIdRegenerateTempPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUserInstitutionIdUserIdRegenerateTempPassword>>, {institutionId: string;userId: string}> = (props) => {
          const {institutionId,userId} = props ?? {};

          return  postApiUserInstitutionIdUserIdRegenerateTempPassword(institutionId,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiUserInstitutionIdUserIdRegenerateTempPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUserInstitutionIdUserIdRegenerateTempPassword>>>

    export type PostApiUserInstitutionIdUserIdRegenerateTempPasswordMutationError = ProblemDetails

    export const usePostApiUserInstitutionIdUserIdRegenerateTempPassword = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUserInstitutionIdUserIdRegenerateTempPassword>>, TError,{institutionId: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiUserInstitutionIdUserIdRegenerateTempPassword>>,
        TError,
        {institutionId: string;userId: string},
        TContext
      > => {
      return useMutation(getPostApiUserInstitutionIdUserIdRegenerateTempPasswordMutationOptions(options), queryClient);
    }
    export const getApiUserAssignableRoles = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AssignableRoleDTO[]>(
      {url: `/api/User/assignable-roles`, method: 'GET', signal
    },
      options);
    }




export const getGetApiUserAssignableRolesInfiniteQueryKey = () => {
    return [
    'infinite', `/api/User/assignable-roles`
    ] as const;
    }

export const getGetApiUserAssignableRolesQueryKey = () => {
    return [
    `/api/User/assignable-roles`
    ] as const;
    }


export const getGetApiUserAssignableRolesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiUserAssignableRoles>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserAssignableRoles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiUserAssignableRolesInfiniteQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserAssignableRoles>>> = ({ signal }) => getApiUserAssignableRoles(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserAssignableRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiUserAssignableRolesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUserAssignableRoles>>>
export type GetApiUserAssignableRolesInfiniteQueryError = unknown


export function useGetApiUserAssignableRolesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiUserAssignableRoles>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserAssignableRoles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserAssignableRoles>>,
          TError,
          Awaited<ReturnType<typeof getApiUserAssignableRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUserAssignableRolesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiUserAssignableRoles>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserAssignableRoles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserAssignableRoles>>,
          TError,
          Awaited<ReturnType<typeof getApiUserAssignableRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUserAssignableRolesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiUserAssignableRoles>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserAssignableRoles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiUserAssignableRolesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiUserAssignableRoles>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiUserAssignableRoles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiUserAssignableRolesInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiUserAssignableRolesQueryOptions = <TData = Awaited<ReturnType<typeof getApiUserAssignableRoles>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserAssignableRoles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiUserAssignableRolesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserAssignableRoles>>> = ({ signal }) => getApiUserAssignableRoles(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiUserAssignableRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiUserAssignableRolesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUserAssignableRoles>>>
export type GetApiUserAssignableRolesQueryError = unknown


export function useGetApiUserAssignableRoles<TData = Awaited<ReturnType<typeof getApiUserAssignableRoles>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserAssignableRoles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserAssignableRoles>>,
          TError,
          Awaited<ReturnType<typeof getApiUserAssignableRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUserAssignableRoles<TData = Awaited<ReturnType<typeof getApiUserAssignableRoles>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserAssignableRoles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserAssignableRoles>>,
          TError,
          Awaited<ReturnType<typeof getApiUserAssignableRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUserAssignableRoles<TData = Awaited<ReturnType<typeof getApiUserAssignableRoles>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserAssignableRoles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiUserAssignableRoles<TData = Awaited<ReturnType<typeof getApiUserAssignableRoles>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserAssignableRoles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiUserAssignableRolesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






